export default {
  cancel: 'global.actions.cancel',
  changePassword: 'components.views.settings-view.change-password',
  oldPassword: 'components.views.settings-view.old-password',
  password: 'components.views.settings-view.new-password',
  confirmPassword: 'components.views.settings-view.confirm-new-password',
  passwordChanged: 'components.views.settings-view.password-changed'
}
